import React from "react";

const VideoFileInput = ({
  id = "fileInput",
  accept = "video/mp4,video/x-matroska,video/quicktime",
  className,
  hidden = true,
  disabled = false,
  capture,
  onChange,
}) => {
  return (
    <input
      id={id}
      type="file"
      accept={accept}
      className={className}
      onChange={onChange}
      hidden={hidden}
      disabled={disabled}
      capture={capture}
    />
  );
};

export default VideoFileInput;


